import type { MetaInfo } from 'vue-meta';

type SeoHeadInput = {
  title?: string | null;
  description?: string | null;
  keywords?: string | null;
  url?: string | null;
  isNoIndex?: boolean;
};

export const getAbsolutePageUrl = (path: string, baseUrl?: string | null): string => {
  const origin = (baseUrl || '').replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return origin ? `${origin}${normalizedPath}` : normalizedPath;
};

export const buildSeoHead = ({ title, description, keywords, url, isNoIndex }: SeoHeadInput): MetaInfo => {
  const seoTags: MetaInfo = {
    meta: [],
  };

  if (title) {
    seoTags.title = title;
    seoTags.meta.push({
      hid: 'og:title',
      name: 'og:title',
      property: 'og:title',
      content: title,
    });
  }

  const ogDescription = description || title;
  if (description) {
    seoTags.meta.push({
      hid: 'description',
      name: 'description',
      content: description,
    });
  }
  if (ogDescription) {
    seoTags.meta.push({
      hid: 'og:description',
      name: 'og:description',
      property: 'og:description',
      content: ogDescription,
    });
  }

  if (url) {
    seoTags.meta.push({
      hid: 'og:url',
      name: 'og:url',
      property: 'og:url',
      content: url,
    });
  }

  if (keywords) {
    seoTags.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: keywords,
    });
  }

  if (isNoIndex) {
    seoTags.meta.push({
      name: 'robots',
      content: 'noindex, nofollow',
    });
  }

  return seoTags;
};
